import { useIntl, defineMessages } from 'react-intl';
import { Container } from 'semantic-ui-react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import LogoComune from './logo_comune.webp';
import LogoComacchio from './logo_comacchio.webp';
import LogoOstellato from './logo_ostellato.webp';
import LogoUnescoFe from './logo_unescofe1.webp';
import LogoUnescoBiosfera from './logo_unesco_biosfera.webp';
import LogoFerraraFeelings from './logo_ferrara_feelings.webp';
import LogoComacchioTrepponti from './logo_comacchio_trepponti.webp';
import LogoERTurismo from './logo_er_turismo.webp';
import LogoRomagna from './logo_romagna.webp';
import LogoMinisteroTurismo from './logo_ministero_turismo.webp';

const FooterMain = (props) => {
  const intl = useIntl();
  return (
    <div className="iv--footer-main" id="footer">
      <Container>
        <div className="footer-logos">
          <div className="col">
            <div>
              <img src={LogoComune} alt="" width="250" height="auto" />
            </div>
            <div className="space-between">
              <img src={LogoComacchio} alt="" width="80.39" height="auto" />
              <img src={LogoOstellato} alt="" width="95.52" height="auto" />
            </div>
          </div>
          <div className="col flex-row">
            <div>
              <img src={LogoUnescoFe} alt="" width="138" height="auto" />
            </div>
            <div>
              <img src={LogoUnescoBiosfera} alt="" width="138" height="auto" />
            </div>
          </div>
          <div className="col">
            <div className="justify-center">
              <img
                src={LogoFerraraFeelings}
                alt=""
                width="128.76"
                height="auto"
              />
            </div>
            <div className="justify-center">
              <img
                src={LogoComacchioTrepponti}
                alt=""
                width="183.97"
                height="auto"
              />
            </div>
            <div className="justify-center">
              <UniversalLink
                href="https://emiliaromagnaturismo.it/it"
                title="emilia romagna turismo"
              >
                <img src={LogoERTurismo} alt="" width="200" height="auto" />
              </UniversalLink>
            </div>
            <div className="justify-center">
              <img src={LogoRomagna} alt="" width="129.01" height="auto" />
            </div>
          </div>
          <div className="col compact">
            <div>
              <img
                src={LogoMinisteroTurismo}
                alt=""
                width="210"
                height="auto"
              />
            </div>
            <div className="footer-logo-text">
              Festina lente – {intl.formatMessage(messages.festina_lente_label)}
            </div>

            <div className="footer-logo-text contacts">
              <div className="mb-2">
                <strong>IAT FERRARA</strong>
                <span>+39 0532 419190</span>
              </div>
              <div className="mb-2">
                <strong>IAT COMACCHIO</strong>
                <span>+39 0533 314154</span>
              </div>
              <div className="mb-2">
                <strong>{intl.formatMessage(messages.email_label)}</strong>
                <a href="mailto:infotur@comune.comacchio.fe.it">
                  infotur@comune.comacchio.fe.it
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FooterMain;

const messages = defineMessages({
  email_label: {
    id: 'email_label',
    defaultMessage: 'E-mail generale per il territorio',
  },
  festina_lente_label: {
    id: 'festina_lente_label',
    defaultMessage:
      'Affrettati lentamente. Ferrara città del Rinascimento e il suo Delta del Po',
  },
});
